import { render, staticRenderFns } from "./StepNumber.vue?vue&type=template&id=6b828e06"
import script from "./StepNumber.vue?vue&type=script&lang=ts"
export * from "./StepNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports